/**
 * Utility functions untuk formatting data
 * Digunakan di seluruh aplikasi untuk konsistensi
 */

/**
 * Format tanggal ke format Indonesia: DD/MM/YYYY HH:mm:ss
 * @param {string|Date} dateString - Tanggal dalam format ISO atau Date object
 * @returns {string} Tanggal terformat
 */
export const formatDateIndonesia = (dateString) => {
  if (!dateString) return '-';
  
  try {
    const date = new Date(dateString);
    
    // Validasi date
    if (isNaN(date.getTime())) {
      return '-';
    }
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    return '-';
  }
};

/**
 * Format currency ke format Indonesia (Accounting)
 * @param {number|string} amount - Jumlah uang
 * @returns {string} Format: Rp 1.234.567,89
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'Rp 0,00';
  
  try {
    const number = typeof amount === 'string' ? parseFloat(amount) : amount;
    
    if (isNaN(number)) return 'Rp 0,00';
    
    // Format dengan separator Indonesia
    const formatted = new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(number);
    
    return formatted;
  } catch (error) {
    return 'Rp 0,00';
  }
};

/**
 * Parse string currency menjadi number
 * @param {string} currencyString - String currency (contoh: "Rp 1.234.567,89")
 * @returns {number} Nilai numerik
 */
export const parseCurrency = (currencyString) => {
  if (!currencyString) return 0;
  
  try {
    // Hapus "Rp", spasi, dan titik (separator ribuan)
    let cleaned = currencyString.replace(/Rp\s?/g, '').replace(/\./g, '');
    // Ganti koma dengan titik untuk decimal
    cleaned = cleaned.replace(',', '.');
    
    return parseFloat(cleaned) || 0;
  } catch (error) {
    return 0;
  }
};

/**
 * Format date untuk input date picker (YYYY-MM-DD)
 * @param {string|Date} dateString - Tanggal
 * @returns {string} Format: YYYY-MM-DD
 */
export const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  } catch (error) {
    return '';
  }
};

/**
 * Get today's date in YYYY-MM-DD format
 * @returns {string} Tanggal hari ini
 */
export const getTodayDate = () => {
  const today = new Date();
  return formatDateForInput(today);
};
